import { render, staticRenderFns } from "./MenuTB.vue?vue&type=template&id=5f31dc6e&scoped=true"
import script from "./MenuTB.vue?vue&type=script&lang=js"
export * from "./MenuTB.vue?vue&type=script&lang=js"
import style0 from "./MenuTB.vue?vue&type=style&index=0&id=5f31dc6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f31dc6e",
  null
  
)

export default component.exports